/**
 * Utilitários para manipulação de URLs no módulo LiveSync
 */

/**
 * Converte uma URL comum do YouTube (watch, share, etc) para o formato de embed.
 * Se a URL já for de embed ou não for do YouTube, retorna a original.
 * 
 * Exemplos suportados:
 * - https://www.youtube.com/watch?v=aqz-KE-bpKQ
 * - https://youtu.be/aqz-KE-bpKQ
 * - https://www.youtube.com/live/aqz-KE-bpKQ
 * - https://youtube.com/shorts/aqz-KE-bpKQ
 */
export function getYoutubeEmbedUrl(url: string): string {
    if (!url) return url;

    // Se já for embed, não faz nada
    if (url.includes('youtube.com/embed/')) return url;

    let videoId = '';

    // Formato youtu.be/ID
    if (url.includes('youtu.be/')) {
        videoId = url.split('youtu.be/')[1].split(/[?#]/)[0];
    }
    // Formato youtube.com/watch?v=ID
    else if (url.includes('v=')) {
        const urlParams = new URL(url).searchParams;
        videoId = urlParams.get('v') || '';
    }
    // Formato youtube.com/live/ID
    else if (url.includes('youtube.com/live/')) {
        videoId = url.split('youtube.com/live/')[1].split(/[?#]/)[0];
    }
    // Formato youtube.com/shorts/ID
    else if (url.includes('youtube.com/shorts/')) {
        videoId = url.split('youtube.com/shorts/')[1].split(/[?#]/)[0];
    }

    if (videoId) {
        return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    }

    return url;
}
